import { render, staticRenderFns } from "./preview-form-step.vue?vue&type=template&id=b96ade66&"
import script from "./preview-form-step.vue?vue&type=script&lang=js&"
export * from "./preview-form-step.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports